/**
 * Caminhos da área do cliente.
 *
 * A página inicial do cliente é o painel (`/user/dashboard`) — é para lá que o
 * login, o atalho `/user` e o fallback de rota levam. `/user/:id` continua
 * sendo "Meu perfil".
 */
export const USER_HOME_PATH = '/user/dashboard';

/** Caminho do perfil do cliente (fallback: o próprio painel). */
export const userProfilePath = (userId) => (userId ? `/user/${userId}` : USER_HOME_PATH);
